var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighRiskGuageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 224,
    viewBox: "0 0 425 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.985 123.275L106.234 28.4432C42.7277 65.187 0 133.853 0 212.5H109.485C109.485 174.374 130.201 141.085 160.985 123.275Z",
    fill: "#4ED27E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.5 109.485C231.269 109.485 248.859 114.503 264.015 123.275L318.766 28.4433C287.503 10.358 251.215 0 212.5 0C173.785 0 137.497 10.358 106.234 28.4433L160.985 123.275C176.141 114.503 193.732 109.485 212.5 109.485Z",
    fill: "#FEE17B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M318.766 28.4432L264.016 123.275C294.799 141.085 315.515 174.374 315.515 212.5H425C425 133.853 382.273 65.187 318.766 28.4432Z",
    fill: "#F84562"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M221.869 220.761L312.185 164.094C316.457 161.22 313.316 154.585 308.384 156.061L207.302 189.978L207.38 190.135C206.61 190.37 205.857 190.661 205.103 191.014C196.606 195.035 192.97 205.189 196.999 213.686C201.027 222.182 211.173 225.818 219.67 221.79C220.416 221.436 221.123 221.036 221.79 220.588L221.869 220.745V220.761ZM203.666 210.537C201.388 205.723 203.446 199.974 208.26 197.697C213.073 195.42 218.822 197.477 221.099 202.291C223.376 207.105 221.319 212.853 216.505 215.131C211.691 217.408 205.943 215.35 203.666 210.537Z",
    fill: "#434A60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRiskGuageIcon);
export default __webpack_public_path__ + "static/media/HighRiskGuageIcon.3a00b1d6f71c19521043b9c2b2b027b9.svg";
export { ForwardRef as ReactComponent };